import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import type { AppLocale } from "../features/cv/types";
import { parseLocale, swapLocalePath } from "../lib/locale";
import { Container } from "../components/ui/Container";
import { ThemeToggle } from "./ThemeToggle";

export function Navbar() {
  const { t, i18n } = useTranslation();
  const { lang: raw } = useParams();
  const lang = parseLocale(raw);
  const location = useLocation();
  const navigate = useNavigate();

  const links = [
    { to: `/${lang}`, label: t("nav.home") },
    { to: `/${lang}/hire-me`, label: t("nav.hireMe") },
    { to: `/${lang}/projects`, label: t("nav.projects") },
    { to: `/${lang}/blog`, label: t("nav.blog") },
    { to: `/${lang}#contact`, label: t("nav.contact") },
  ];

  const switchLang = (next: AppLocale) => {
    void i18n.changeLanguage(next);
    navigate(swapLocalePath(location.pathname, next) + location.hash);
  };

  return (
    <nav className="bx-nav sticky top-0 z-30 border-b backdrop-blur-md" aria-label="Main">
      <Container className="flex h-16 items-center justify-between gap-4">
        <Link to={`/${lang}`} className="text-lg font-bold" style={{ color: "var(--color-primary)" }}>
          N.S
        </Link>
        <ul className="hidden items-center gap-6 md:flex">
          {links.map((l) => (
            <li key={l.to}>
              <Link to={l.to} className="bx-text-muted text-sm font-medium transition hover:[color:var(--color-primary)]">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
        <div className="flex items-center gap-3">
          <div
            className="bx-border flex rounded-lg border p-0.5 text-xs font-semibold"
            role="group"
            aria-label={t("a11y.lang")}
          >
            <button
              type="button"
              className={`bx-focus rounded px-2.5 py-1 transition ${lang === "pt" ? "text-white" : "bx-text-muted"}`}
              style={lang === "pt" ? { backgroundColor: "var(--color-primary)" } : undefined}
              onClick={() => switchLang("pt")}
            >
              PT
            </button>
            <button
              type="button"
              className={`bx-focus rounded px-2.5 py-1 transition ${lang === "en" ? "text-white" : "bx-text-muted"}`}
              style={lang === "en" ? { backgroundColor: "var(--color-primary)" } : undefined}
              onClick={() => switchLang("en")}
            >
              EN
            </button>
          </div>
          <ThemeToggle />
        </div>
      </Container>
    </nav>
  );
}
